(() => {
  'use strict';
  const root = () => window.Shopify?.routes?.root || '/';
  let cartBusy = false;
  let draftNote = null;
  let refreshVersion = 0;
  const surfaces = () => [...document.querySelectorAll('[data-cart-surface]')];
  const setCartBusy = busy => surfaces().forEach(surface => {
    if (busy) surface.setAttribute('aria-busy', 'true');
    else surface.removeAttribute('aria-busy');
    surface.querySelectorAll('[data-cart-quantity],[data-cart-remove],.tr-checkout').forEach(control => {
      if (busy) {
        if (!('wasDisabled' in control.dataset)) control.dataset.wasDisabled = String(control.disabled);
        control.disabled = true;
      } else if ('wasDisabled' in control.dataset) {
        control.disabled = control.dataset.wasDisabled === 'true';
        delete control.dataset.wasDisabled;
      }
    });
  });
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-open-cart]').forEach(el => el.setAttribute('aria-label', `Carrinho · ${count} artigos`));
  }
  function replaceSurface(target, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('[data-cart-surface]');
    if (!incoming || !target) throw Error('A quantidade foi atualizada. Abre a página do carrinho para continuar.');
    target.replaceWith(incoming);
    bind(incoming.parentElement);
    if (cartBusy) setCartBusy(true);
    return incoming;
  }
  async function fetchSection(section, path = '') {
    const url = new URL(root() + path, location.origin);
    url.searchParams.set('section_id', section);
    const response = await fetch(url, {headers: {Accept: 'text/html'}});
    if (!response.ok) throw Error('Não foi possível atualizar o carrinho. Tenta novamente.');
    return response.text();
  }
  async function updateCart(key, quantity, origin) {
    if (cartBusy) return;
    cartBusy = true;
    refreshVersion++;
    setCartBusy(true);
    const status = origin.querySelector('[data-cart-status]');
    status.textContent = 'A atualizar o carrinho…';
    const pageSection = document.querySelector('[data-cart-page-section]')?.dataset.cartPageSection;
    const requested = ['trazzo-cart-drawer', ...(pageSection ? [pageSection] : [])];
    try {
      const response = await fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: key, quantity, sections: requested, sections_url: root() + 'cart'})
      });
      const cart = await response.json();
      if (!response.ok) throw Error(cart.description || 'Não foi possível atualizar a quantidade.');
      updateCount(cart.item_count);
      for (const section of requested) {
        const html = cart.sections?.[section] || await fetchSection(section, section === 'trazzo-cart-drawer' ? '' : 'cart');
        const target = section === 'trazzo-cart-drawer'
          ? document.querySelector('[data-cart-dialog] [data-cart-surface]')
          : document.querySelector('#MainContent [data-cart-surface]');
        replaceSurface(target, html);
      }
    } catch (error) {
      surfaces().forEach(surface => {
        surface.querySelector('[data-cart-status]').textContent = error.message || 'Não foi possível atualizar. Tenta novamente.';
      });
    } finally {
      cartBusy = false;
      setCartBusy(false);
    }
  }
  function bind(scope) {
    scope.querySelectorAll('[data-open-search]').forEach(link => {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', event => {
        const dialog = document.querySelector('[data-search-dialog]');
        if (!dialog) return;
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
        dialog.querySelector('input[type=search]').focus();
      });
    });
    scope.querySelectorAll('[data-search-form]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const input = form.querySelector('input[type=search]');
      const results = form.querySelector('[data-predictive-results]');
      const status = form.querySelector('[data-search-status]');
      let timer, controller, sequence = 0;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        controller?.abort();
        const request = ++sequence;
        const query = input.value.trim();
        results.replaceChildren();
        results.removeAttribute('aria-busy');
        status.textContent = '';
        results.hidden = query.length < 2;
        if (query.length < 2) return;
        timer = setTimeout(async () => {
          controller = new AbortController();
          results.setAttribute('aria-busy', 'true');
          status.textContent = 'A procurar…';
          try {
            const url = new URL(form.dataset.predictiveUrl, location.origin);
            url.searchParams.set('q', query);
            url.searchParams.set('section_id', 'trazzo-predictive-search');
            url.searchParams.set('resources[type]', 'product,page');
            url.searchParams.set('resources[limit]', '5');
            url.searchParams.set('resources[options][unavailable_products]', 'hide');
            const response = await fetch(url, {signal: controller.signal, headers: {Accept: 'text/html'}});
            if (!response.ok) throw Error();
            const html = await response.text();
            if (request !== sequence) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const content = doc.querySelector('[data-predictive-content]');
            if (!content) throw Error();
            results.replaceChildren(content);
            status.textContent = content.querySelector('[data-no-results]') ? 'Experimenta outra palavra ou vê todos os resultados.' : '';
          } catch (error) {
            if (error.name !== 'AbortError' && request === sequence) status.textContent = 'Podes continuar através do botão Pesquisar.';
          } finally {
            if (request === sequence) results.removeAttribute('aria-busy');
          }
        }, 220);
      });
    });
    scope.querySelectorAll('[data-open-cart]').forEach(link => {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', event => {
        if (!document.querySelector('[data-cart-dialog]')) return;
        event.preventDefault();
        window.TrazzoCart.open();
      });
    });
    scope.querySelectorAll('[data-discount-apply]').forEach(button => {
      if (button.dataset.couponBound) return;
      button.dataset.couponBound = 'true';
      button.addEventListener('click', () => {
        const code = button.closest('form').querySelector('[data-discount-code]').value.trim();
        if (code) location.assign(`${root()}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root() + 'cart')}`);
      });
    });
    scope.querySelectorAll('[data-cart-surface]').forEach(surface => {
      if (surface.dataset.bound) return;
      surface.dataset.bound = 'true';
      const note = surface.querySelector('textarea[name=note]');
      if (note) {
        if (draftNote === null) draftNote = note.value;
        else note.value = draftNote;
        note.addEventListener('input', () => {
          draftNote = note.value;
          document.querySelectorAll('[data-cart-surface] textarea[name=note]').forEach(other => { other.value = draftNote; });
        });
      }
      surface.querySelectorAll('[data-cart-quantity]').forEach(input => input.addEventListener('change', () => {
        const quantity = Number(input.value);
        if (!input.checkValidity() || !Number.isInteger(quantity)) { input.reportValidity(); return; }
        updateCart(input.dataset.key, quantity, surface);
      }));
      surface.querySelectorAll('[data-cart-remove]').forEach(button => button.addEventListener('click', () => updateCart(button.dataset.key, 0, surface)));
    });
  }
  window.TrazzoCart = {
    async refresh() {
      const version = ++refreshVersion;
      const html = await fetchSection('trazzo-cart-drawer');
      if (version !== refreshVersion) return;
      const surface = replaceSurface(document.querySelector('[data-cart-dialog] [data-cart-surface]'), html);
      updateCount(Number(surface.dataset.count));
    },
    async open() {
      const dialog = document.querySelector('[data-cart-dialog]');
      if (!dialog) { location.assign(root() + 'cart'); return; }
      if (!dialog.open) dialog.showModal();
      if (cartBusy) return;
      dialog.setAttribute('aria-busy', 'true');
      try { await this.refresh(); }
      catch (error) { dialog.querySelector('[data-cart-status]').textContent = 'Não foi possível atualizar. Abre a página do carrinho para continuar.'; }
      finally { dialog.removeAttribute('aria-busy'); }
    }
  };
  document.addEventListener('DOMContentLoaded', () => bind(document));
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
